// src/core/onboard/UI/LoginLayout.tsx
import React, { ReactNode, useEffect, useState } from "react";
import styled from "styled-components";
import { useMediaQuery } from "@chakra-ui/react";
import { PrimaryColorPalette } from "lib/styles/colors";

const leftPlaceholder =
  "data:image/jpg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wEEEAARABEAEQARABIAEQATABUAFQATABoAHAAZABwAGgAmACMAIAAgACMAJgA6ACoALQAqAC0AKgA6AFgANwBAADcANwBAADcAWABOAF8ATQBIAE0AXwBOAIwAbgBiAGIAbgCMAKIAiACBAIgAogDFALAAsADFAPgA6wD4AUMBQwGzEQARABEAEQARABIAEQATABUAFQATABoAHAAZABwAGgAmACMAIAAgACMAJgA6ACoALQAqAC0AKgA6AFgANwBAADcANwBAADcAWABOAF8ATQBIAE0AXwBOAIwAbgBiAGIAbgCMAKIAiACBAIgAogDFALAAsADFAPgA6wD4AUMBQwGz/8IAEQgAhwCAAwEiAAIRAQMRAf/EACwAAQEBAQAAAAAAAAAAAAAAAAABAgYBAQEBAQAAAAAAAAAAAAAAAAABAgP/2gAMAwEAAhADEAAAAOd1jfTiCZItCwTQAADUtxUJJYus2KE0AABU1cAmRdWEBNAAAUXFCZF1YQE0AAAGs6EzkXSyxBNAAABrNssmRassQTQAAAazbmyQWrKQZ0AAAGsrKQAFlmaCgABrIFgAWGaCgAf/xAAcEAEAAwEBAAMAAAAAAAAAAAABABAwMSBAQVD/2gAIAQEAAT8AhTyFEe5FMKI9yKbI9yKfD3Ip8PcimyORTZHujZHuRT4dHw/AefoEcyPhzI+Hmj4+sP/EABgRAQADAQAAAAAAAAAAAAAAAAEQMEAg/9oACAECAQE/AJcDQ0NDpeP/xAAaEQACAwEBAAAAAAAAAAAAAAABECAwQTEA/9oACAEDAQE/AFvh2gS0IdloQ7RtxoLEghD/2Q==";
const rightPlaceholder =
  "data:image/jpg;base64,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";

const defaultLeftUrl = "/images/home_background_left.webp";
const defaultRightUrl = "/images/home_background_right.webp";

// This component just provides the "split screen" layout:
// - Left half is the background + children content
// - Right half is a second background, hidden below ~tablet width
// - We allow optional placeholders if you have not decided on final images
interface Props {
  children: ReactNode;
  leftImageUrl?: string;
  rightImageUrl?: string;
}

interface PanelProps {
  backgroundUrl: string;
  children?: React.ReactNode;
}

export default function LoginLayout({
  children,
  leftImageUrl = "/images/home_background_left.webp",
  rightImageUrl = "/images/home_background_right.webp",
}: Props) {
  // Hide the right panel below 768px (tablet)
  const [isBelowTablet] = useMediaQuery("(max-width: 768px)");
  // Track when the large image is fully loaded
  const [leftLoaded, setLeftLoaded] = useState(false);
  const [rightLoaded, setRightLoaded] = useState(false);

  // Preload left image
  useEffect(() => {
    const img = new Image();
    img.src = leftImageUrl;
    img.onload = () => setLeftLoaded(true);
  }, [leftImageUrl]);

  // Preload right image
  useEffect(() => {
    const img = new Image();
    img.src = rightImageUrl;
    img.onload = () => setRightLoaded(true);
  }, [rightImageUrl]);

  return (
    <LayoutContainer>
      <LeftPanel backgroundUrl={leftLoaded ? leftImageUrl : leftPlaceholder}>
        {/* Put the actual login form in the center */}
        <FormContainer>{children}</FormContainer>
      </LeftPanel>

      {/* Hide the right image on smaller screens */}
      {!isBelowTablet && (
        <RightPanel
          backgroundUrl={rightLoaded ? rightImageUrl : rightPlaceholder}
        />
      )}
    </LayoutContainer>
  );
}

const LayoutContainer = styled.div`
  display: flex;
  width: 100vw;
  height: 100vh;
`;

// Left side is the background behind the form
const LeftPanel = styled.div<PanelProps>`
  flex: 1;
  background-image: url(${(props) => props.backgroundUrl});
  background-size: cover;
  background-position: center;
  position: relative;
`;

// Right side is a second image, hidden at tablet sizes
const RightPanel = styled.div<PanelProps>`
  flex: 1;
  background-image: url(${(props) => props.backgroundUrl});
  background-size: cover;
  background-position: right;
`;

// We absolutely position the login form in the center of the left panel
const FormContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  /* Just a convenient max width/padding. */
  background-color: transparent;
  padding: 2rem;
  border-radius: 12px;
  width: 90%;
  max-width: 400px;
`;
